import { object } from "../../../../helpers/object";
import { debug } from "../../../../helpers/debug";

/*------------------------------------*\
  #TEXTAERA

  Gestion de fake textaera pour des raison SEO
\*------------------------------------*/
class FormTextarea {


  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;

    document.addEventListener('input', this.keyHandler);

    this.DOM_MODULE.forEach((item) => {
      this.limitCharacteres(item.querySelector('[data-js-trigger="textarea"]'));
    });

    if(debug.DEBUG) console.log('async/form/modules/field-behavior/textarea.js');
  };
  /**
   * KEY HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  keyHandler = (event) => {
    if (event.target.matches('[data-js-trigger="textarea"]')) {
      this.limitCharacteres(event.target);
    }
  }
  /**
   * Limits the number of characters in a textarea to the specified maxlength attribute or a default of 3000.
   * Updates the remaining character count.
   *
   * @param {HTMLTextAreaElement} target - The textarea element to limit characters for.
   */
  limitCharacteres = (target) => {
    const limit = parseInt(target.getAttribute('maxlength')) || 3000;
    const value = target.value.slice(0, limit);
    target.value = value;
    this.setRemaining(target, limit - value.length);
  }
  /**
   * Updates the text content of the element displaying the remaining character count.
   *
   * @param {HTMLElement} target - The target textarea element.
   * @param {number} remaining - The number of remaining characters to display.
   */
  setRemaining = (target, remaining) => {
    const remainingEle = target.closest('[data-js-component]').querySelector('.js-characters-remaining-text');
    remainingEle.textContent = remainingEle.textContent.replace(/\d+/, remaining);
  };
}
export default new FormTextarea('[data-js-component="textarea"]'); 